import { render, staticRenderFns } from "./Adjustments.vue?vue&type=template&id=847df4ce&scoped=true&"
import script from "./Adjustments.vue?vue&type=script&lang=js&"
export * from "./Adjustments.vue?vue&type=script&lang=js&"
import style0 from "./Adjustments.vue?vue&type=style&index=0&id=847df4ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "847df4ce",
  null
  
)

export default component.exports